<form [formGroup]="forgotForm">
  <div class="c-forgot-page" fxLayout="column" fxLayoutAlign="center center">
    <div class="c-login-logo">
      <img [src]="logoURL ? logoURL : 'assets/images/logo-brand-pmc.svg'" />
    </div>
    <div class="c-status-message">
      <p
        *ngIf="isValidateError"
        class="u-background-color-error u-font-color-white u-padding-10 u-text-center"
      >
        {{validationError}}
      </p>
    </div>
    <div class="c-forgot-box">
      <mat-form-field class="mat-block" appearance="fill">
        <input
          matInput
          [placeholder]="'secret_word.text_secret_word' | translate"
          formControlName="secretWord"
          required
          value=""
        />
        <mat-error
          id="matSecretWordRequired"
          class="error-message"
          *ngIf="
          forgotForm.get('secretWord').dirty ||
          forgotForm.get('secretWord').touched"
        >
          {{ "secret_word.secret_word_validation" | translate }}
        </mat-error>
      </mat-form-field>

      <div class="u-margin-bottom-15 u-margin-bottom-5">
        {{"secret_word.text_user_name" | translate}}
        <mat-slide-toggle
          id="matSelectToggleUserName"
          formControlName="isUserName"
          class="c-toggle-btn u-padding-left-10 u-padding-right-10"
          (change)="updateFormValidation()"
        >
        </mat-slide-toggle>
        {{"secret_word.text_email" | translate}}
      </div>
      <span [hidden]="forgotForm.get('isUserName').value">
        <mat-form-field class="mat-block" appearance="fill">
          <input
            matInput
            [placeholder]="'secret_word.text_user_name' | translate"
            formControlName="userName"
            (keydown)="noWhiteSpaceAllow($event)"
          />
          <mat-error
            id="matUserNameRequired"
            class="error-message"
            *ngIf="
            (forgotForm.get('userName').dirty ||
            forgotForm.get('userName').touched)  && forgotForm.get('userName').hasError('required')"
          >
            {{ "secret_word.user_name_word_validation" | translate }}
          </mat-error>
          <mat-error
            id="matUserNameInvalid"
            class="error-message"
            *ngIf="
            (forgotForm.get('userName').dirty ||
            forgotForm.get('userName').touched) && forgotForm.get('userName').hasError('pattern')
          "
          >
            {{ "secret_word.invalid_username" | translate }}
          </mat-error>
        </mat-form-field>
      </span>
      <span [hidden]="!forgotForm.get('isUserName').value">
        <mat-form-field class="mat-block" appearance="fill">
          <input
            matInput
            [placeholder]="'secret_word.text_email' | translate"
            formControlName="email"
          />
          <mat-error
            id="matEmailRequired"
            class="error-message"
            *ngIf="
            (forgotForm.get('email').dirty ||
            forgotForm.get('email').touched) && forgotForm.get('email').hasError('required')"
          >
            {{ "secret_word.email_id_validation" | translate }}
          </mat-error>

          <mat-error
            id="matEmailInvalid"
            class="error-message"
            *ngIf="
        (forgotForm.get('email').dirty || forgotForm.get('email').touched) && forgotForm.get('email').hasError('email')"
          >
            {{ "secret_word.email_validation" | translate }}
          </mat-error>
        </mat-form-field>
      </span>
      <button
        mat-button
        mat-flat-button
        color="primary"
        class="c-forgot-button u-margin-top-5"
        (click)="checkSecretWordAnduserDetails()"
        [disabled]="forgotForm.invalid"
      >
        {{ "secret_word.btn_next" | translate }}
      </button>
    </div>
  </div>
</form>
